cv.TeamDonationsRowView = Marionette.ItemView.extend({
  tagName: 'tr',
  className : 'tr-selectable',

  template : cv.Templates['team/donations_row'],

  events : {
  },

  initialize: function(){
    console.log('TeamDonationsRowView initialized');
  },

  templateHelpers: function(){
    moment().utc();

    if(this.model.get('recipient.type') == 'campaign'){
      var to = 'Campaign Page';
    }else{
      if(this.model.get('recipient.type') == 'fundraiser'){
        var to = '<i class="fa fa-fw fa-user"></i> <a href="/' + this.model.get('recipient.stub') + '" target="_blank" data-bypass="true">' + this.model.get('recipient.name') + '</a>';
      }else{
        var to = '<i class="fa fa-fw fa-users"></i> <a href="team/' + this.model.get('recipient.stub') + '" target="_blank" data-bypass="true">' + this.model.get('recipient.name') + '</a>';
      }
    }

    return {
      anonymous : this.model.get('anonymous') == 1 ? '1' : null,
      name : this.model.get('display_name'),
      email : this.model.get('email'),
      amount : cv.formatMoney({
        show_sign : true,
        amount : this.model.get('amount'),
        currency_code : cv.campaign.get('currency_code'),
        decimal_places : 2
      }),
      to : to,
      created_at_date : moment(this.model.get('created_at') + 'Z').tz(cv.campaign.get('timezone')).format('MMM D'),
      created_at_time :  moment(this.model.get('created_at') + 'Z').tz(cv.campaign.get('timezone')).format('h:mm A')
    }
  },

  onAttach: function(){
  }
});
